import React, { FC } from "react";
import { Link } from "react-router-dom";

type Props = {
  title: string;
  text?: string;
  linkTo: string;
  linkLabel: string;
};

/**
 * Friendly "not found" message inside the app layout (QA batch 13, SEC-001 / SEC-006):
 * an unknown or deleted work item, or an app address that doesn't exist.
 */
export const NotFoundPanel: FC<Props> = ({
  title,
  text,
  linkTo,
  linkLabel,
}) => (
  <div className={"flex w-full justify-center px-4 py-16"} role={"alert"}>
    <div
      className={
        "w-full max-w-[460px] rounded-[14px] border border-[#DCE2EA] bg-white px-6 py-8 text-center shadow-[0_1px_2px_rgba(20,22,34,0.04)]"
      }>
      <div className={"text-[18px] font-bold text-[#1F2433]"}>{title}</div>
      {text && <div className={"mt-2 text-[14px] text-[#5B6275]"}>{text}</div>}
      <Link
        to={linkTo}
        className={
          "mt-5 inline-flex h-10 items-center rounded-lg bg-[#6B4EFF] px-5 text-[14px] font-semibold text-white hover:bg-[#5A3EEB]"
        }>
        {linkLabel}
      </Link>
    </div>
  </div>
);

/** Unknown app address (route "*" inside the signed-in layout). */
export const NotFoundPage: FC = () => (
  <NotFoundPanel
    title={"Page not found"}
    text={
      "This address doesn't exist in ProCharted. It may be an old or mistyped link."
    }
    linkTo={"/home"}
    linkLabel={"Go to Home"}
  />
);
